export const TRANSACTIONS_FETCH = '@CS/TRANSACTIONS_FETCH';
export const TRANSACTIONS_FETCH_SUCCESS = '@CS/TRANSACTIONS_FETCH_SUCCESS';
export const TRANSACTIONS_FETCH_ERROR = '@CS/TRANSACTIONS_FETCH_ERROR';

export const TRANSACTIONS_AUTH = '@CS/TRANSACTIONS_AUTH';
export const TRANSACTIONS_AUTH_SUCCESS = '@CS/TRANSACTIONS_AUTH_SUCCESS';
export const TRANSACTIONS_AUTH_ERROR = '@CS/TRANSACTIONS_AUTH_ERROR';

export const TRANSACTIONS_UPDATE = '@CS/TRANSACTIONS_UPDATE';
export const TRANSACTIONS_UPDATE_SUCCESS = '@CS/TRANSACTIONS_UPDATE_SUCCESS';
